import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

import { ref } from 'vue'
import { IonModal } from '@ionic/vue'
import { useGrid } from 'vue-screen'
import { useGwModal } from '@/plugins/gw-modal'
import AddToCalendar from '@/components/Calendar/AddToCalendar.vue'
import { useEvents } from '@/composables/events'
import { OrderReservation } from '@/models/order'
import GwBottomSheet from '@/plugins/gw-modal/GwBottomSheet.vue'
import GwModal from '@/plugins/gw-modal/GwModal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AddToCalendarModal',
  setup(__props) {

const grid = useGrid('tailwind')
const gwModal = useGwModal()
const modalOpen = ref(false)
const modalType = ref<'bottomSheet' | 'overlay'>(grid.breakpoint ? 'overlay' : 'bottomSheet')
const { modalEventBus } = useEvents()
const order = ref<OrderReservation>()

const openCalendarModal = () => {
	modalType.value = grid.breakpoint ? 'overlay' : 'bottomSheet'
	modalOpen.value = true
}
const onModalWillDismiss = () => modalEventBus.emit('close', { type: 'calendar' })
const onModalDismiss = (data: any) => {
	modalOpen.value = false
	modalEventBus.emit('closed', { data, type: 'calendar' })
}
modalEventBus.on((event, payload) => {
	if (payload?.type !== 'calendar') return
	if (event === 'open') {
		order.value = payload.data.order
		openCalendarModal() 
	}
	else if (event === 'close') modalOpen.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonModal), {
    id: "CalendarModal",
    animated: true,
    class: _normalizeClass(modalType.value === 'bottomSheet' ? 'gw-modal-sheet' : ''),
    "enter-animation": modalType.value === 'overlay' ? _unref(gwModal).enterAnimationDefinition : undefined,
    "leave-animation": modalType.value === 'overlay' ? _unref(gwModal).leaveAnimationDefinition : undefined,
    "is-open": modalOpen.value,
    breakpoints: modalType.value === 'bottomSheet' ? [0,1] : undefined,
    "initial-breakpoint": modalType.value === 'bottomSheet' ? 1 : undefined,
    "can-dismiss": true,
    onWillDismiss: onModalWillDismiss,
    onDidDismiss: onModalDismiss
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(modalType.value === 'bottomSheet' ? GwBottomSheet : GwModal), { name: "CalendarModal" }, {
        default: _withCtx(() => [
          _createVNode(AddToCalendar, { order: order.value }, null, 8, ["order"])
        ]),
        _: 1
      }))
    ]),
    _: 1
  }, 8, ["class", "enter-animation", "leave-animation", "is-open", "breakpoints", "initial-breakpoint"]))
}
}

})